import React from "react";
import "../CSS/Footer.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Footer = () => {
   const navigate = useNavigate();
  return (
    <>
      <footer className="footer_wrapper">
        <div className="container">
          <section className="cta_section">
            <h2 className="text_center">Ready to Transform Your Business</h2>
            <p className="text_center">
              Let's discuss your project and create something extraordinary
              together. Get your free consultation and quote.
            </p>
            <div className="mt20 flex justify_center">
              <button className="btn tertiary_button" onClick={() => {navigate("/contact")}}>Get In Touch</button>
            </div>
          </section>
          <nav className="footer_links" aria-label="Footer navigation">
            <div className="item">
              <h5 className="mb10">Syncnode</h5>
              <p>
                <small>
                  Enterprise-grade digital solutions for ambitious businesses.
                  We build, automate, and scale your vision into reality.
                </small>
              </p>
            </div>
            <div className="item">
              <h6>Services</h6>
              <p className="mt10">
                <small>Web Development</small>
              </p>
              <p className="mt5">
                <small>Mobile Apps</small>
              </p>
              <p className="mt5">
                <small>Automation</small>
              </p>
              <p className="mt5">
                <small>Ecommerce Solutions</small>
              </p>
            </div>
            <div className="item">
              <h6>Company</h6>
              <p className="mt10">
                <Link to="/privacypolicy">
                  <small>Privacy Policy</small>
                </Link>
              </p>
              <p className="mt5">
                <Link to="/refundpolicy">
                  <small>Refund Policy</small>
                </Link>
              </p>
              <p className="mt5">
                <Link to="/termsandconditions">
                  <small>Terms and Conditions</small>
                </Link>
              </p>
              <p className="mt5">
                <Link to="/contact">
                  <small>Contact</small>
                </Link>
              </p>
            </div>
            <div className="item">
              <h6>Contact</h6>
              <p className="mt10">
                <small>info@syncnode.in</small>
              </p>
              <p className="mt5">
                <small>+91 7876666787</small>
              </p>
              <p className="mt5">
                <small>Hisar,Haryana, India</small>
              </p>
            </div>
          </nav>
          <div className="copyright text_center">
            <p>
              <small>© 2025 Syncnode. All rights reserved.</small>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
